module.exports = __webpack_public_path__ + "static/media/disco-corte.bb2a83b4.jpg";